module.exports = __webpack_public_path__ + "img/b200fe147a214d3898ae25f8c1414514.445a0994.jpg";